/** CSS for colored console output */
export const cssText = "color: #4CAF50; font-weight: bold;";